import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft } from 'lucide-react';
import { memo } from 'react';
import { usePricing } from '../../../hooks/usePricing';
import { useUpdatePricing } from '../../../hooks/useUpdatePricing';
import { V2PricingWorkspace } from './V2PricingWorkspace';
export const PricingWorkspace = /*#__PURE__*/ memo(function PricingWorkspace({ projectId, pricingId, scenarioName, onBack }) {
    const { data, isLoading, error } = usePricing(projectId, pricingId);
    const updateMutation = useUpdatePricing(projectId, pricingId);
    const pricing = data?.pricing;
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex items-center justify-center h-64",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center gap-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm text-gray-500",
                        children: "Loading pricing scenario..."
                    })
                ]
            })
        });
    }
    if (error || !pricing) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ _jsxs("button", {
                    onClick: onBack,
                    className: "flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700",
                    children: [
                        /*#__PURE__*/ _jsx(ArrowLeft, {
                            className: "w-4 h-4"
                        }),
                        "Back to Scenarios"
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex items-center justify-center h-64",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "text-red-500",
                        children: "Failed to load pricing scenario"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(V2PricingWorkspace, {
        pricing: pricing,
        scenarioName: scenarioName,
        onBack: onBack,
        updateMutation: updateMutation
    });
});
